import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "udi-section p-2" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" GMDN PT Name ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Device Description ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Brand Name ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Version or Model ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Company Name: ", -1 /* HOISTED */)
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" What MRI safety information does the labeling contain? ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "mb-0" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Device required to be labeled as containing natural rubber latex or dry natural rubber (21 CFR 801.437) ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Lot/Batch Number: ", -1 /* HOISTED */)
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Serial Number: ", -1 /* HOISTED */)
const _hoisted_43 = { class: "mb-0" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Expiration Date: ", -1 /* HOISTED */)
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Manufacturing Date: ", -1 /* HOISTED */)
const _hoisted_47 = { class: "mb-0" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, " Issuing Agency: ", -1 /* HOISTED */)
const _hoisted_49 = { class: "mb-0" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Human cell, tissue or cellular or tissue-based product (HCT/P) ")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_55 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, [
        _hoisted_3,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_5)), [
          [_directive_tooltip, { title: _ctx.gmdnPtNameTooltip }]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.implantableDevice.Name), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_8, [
        _hoisted_9,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_11)), [
          [_directive_tooltip, { title: _ctx.deviceTooltip }]
        ]),
        _hoisted_12
      ]),
      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.implantableDevice.Description), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_14, [
        _hoisted_15,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_17)), [
          [_directive_tooltip, { title: _ctx.brandNameTooltip }]
        ]),
        _hoisted_18
      ]),
      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.implantableDevice.BrandName), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_20, [
        _hoisted_21,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_23)), [
          [_directive_tooltip, { title: _ctx.versionTooltip }]
        ]),
        _hoisted_24
      ]),
      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.implantableDevice.VersionModelNumber), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_26,
      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.implantableDevice.CompanyName), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_28, [
        _hoisted_29,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_31)), [
          [_directive_tooltip, { title: _ctx.mriTooltip }]
        ]),
        _hoisted_32
      ]),
      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.implantableDevice.SafetyInformation), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_34, [
        _hoisted_35,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_37)), [
          [_directive_tooltip, { title: _ctx.deviceLabelTooltip }]
        ]),
        _hoisted_38
      ]),
      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.implantableDevice.HasNaturalRubber), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_40,
      _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.implantableDevice.LotBatchNumber), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_42,
      _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.implantableDevice.SerialNumber), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_44,
      _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.formatDate(_ctx.implantableDevice.ExpirationDate)), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_46,
      _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.formatDate(_ctx.implantableDevice.ManufacturingDate)), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _hoisted_48,
      _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.implantableDevice.IssuingAgency), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_50, [
        _hoisted_51,
        _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_53)), [
          [_directive_tooltip, { title: _ctx.hctTooltip }]
        ]),
        _hoisted_54
      ]),
      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.implantableDevice.IsHumanOrIssueProduct ? "YES" : "NO"), 1 /* TEXT */)
    ])
  ]))
}